import React from 'react';
import { useState } from 'react';
import Div from '../Div';
const accordionData = [
  {
    question: 'What exactly does Calaxer do, and how is it different from other agencies?',
    answer: `We don’t just make content. We run the entire content system for founders and companies.
We handle short-form, podcasts, personal branding, and brand content with a strong focus on distribution so your content drives visibility, trust, and inbound opportunities.`,
  },
  {
    question: 'Do you launch podcasts?',
    answer: `Yes. We launch and manage podcasts end-to-end including recording, editing, publishing, and converting each episode into short-form clips for Instagram, YouTube, and LinkedIn.`,
  },
  {
    question: 'Do we need to come in person for recording, or do you handle it?',
    answer: `Both options are available.
You can record at our studio in Delhi NCR, or our own team can handle the full recording setup on-site including scripting, shooting, editing, sound design, and distribution. You do not need to arrange anything from your side.`,
  },
  {
    question: 'Do you handle in-person interviews or multi-guest shoots?',
    answer: `Yes. Our Delhi NCR studio supports professional podcast and interview recording with multiple guests and multi-camera setups.`,
  },
  {
    question: 'How does the end-to-end process work?',
    answer: `Our workflow is simple and structured:

  1. Research and Pre-Production (topics, scripts, brainstorming, brand alignment)

  2. Recording (studio or on-site)

  3. Post-Production (editing, design, animations, audio mastering)

  4. Approvals and final edits

  5. Distribution and promotion (short-form, long-form, and optional paid ads)

  Everything is tailored to your brand and designed to compound visibility, trust, and inbound over time.`,
  },

  {
    question: 'Do I need to manage anything from my side?',
    answer: `If we are building your founder's personal brand, you just show up and speak. We handle everything else.

If we are running your company content, you do not need to record anything. Our team manages the entire content system independently.`,
  },
  {
    question: 'How fast can we start seeing results?',
    answer: `Most clients start noticing a clear lift in visibility and inbound conversations within 60 to 90 days of consistent posting and distribution.`,
  },
];


export default function Accordion() {
  const [selected, setSelected] = useState(0);
  const handelToggle = index => {
    if (selected === index) {
      return setSelected(null);
    }
    setSelected(index);
  };

  return (
    <Div className="cs-accordians cs-style1">
      {accordionData.map((item, index) => (
        <Div
          className={`cs-accordian ${selected === index ? 'active' : ''}`}
          key={index}
        >
          <Div
            className="cs-accordian_head"
            onClick={() => handelToggle(index)}
          >
            <h3 className="cs-accordian_title">{item.question}</h3>
              <span className="cs-accordian_toggle cs-accent_color">
                <svg
                  width={15}
                  height={8}
                  viewBox="0 0 15 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0 0L7.5 7.5L15 0H0Z" fill="currentColor" />
                </svg>
              </span>
          </Div>
          <Div className="cs-accordian_body">
            <Div className="cs-accordian_body_in">{item.answer}</Div>
          </Div>
        </Div>
      ))}
    </Div>
  );
}
